module.exports = __webpack_public_path__ + "img/bg-el-cielo.d01ecc64.jpg";